<mat-expansion-panel [disabled]="actionDisabled"  (opened)="getNotificationsByKeyName()" hideToggle="true" (click)="click()" class="expandable-panel" *ngIf="isReady">
    <mat-expansion-panel-header collapsedHeight="72px" expandedHeight="88px" matExpansionToggleIndicatorPosition="before">
        <mat-panel-title class="custom-panel-title">
            <mat-icon>{{iconDown  ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
            <div class="title-container">
                <h3 matLine class="typo w-100 body-1 semi-condensed fw400 label-title">{{title}}</h3>
                <p matLine class="typo w-100 note semi-condensed fw300 label-subtitle">{{subtitle}}</p>
            </div>
        </mat-panel-title>
        <mat-panel-description>
            <div class="panel-description" [routerLink]="['./', _notificationSectionKeyName, 'list']">
                <a mat-icon-button class="edit-icon custom-mat-icon-button">
                    <mat-icon svgIcon="ico-edit" class="custom-mat-icon ico-size ico-1xs"></mat-icon>
                </a>
                <span class="edit-text">View / Manage</span>
            </div>
        </mat-panel-description>
        
    </mat-expansion-panel-header>

    <ng-container *ngIf="!loading">
        <div class='notification-list-item' *ngFor="let notification of notifications">
            <span class="typo subheading-1 fw400 semi-condensed italic">{{notification.systemEvent.displayName}}
                ({{notification.companyNotificationChannels.length}}) active notification(s)</span>
        </div>
        <div class="notification-list-item" *ngIf="!loading && notifications.length === 0">
            There are no active notifications
        </div>
    </ng-container>

    <ng-container *ngIf="loading">
        <p matLine><skeleton-loader [theme]="{'height':'50px','width': '40%'}"></skeleton-loader></p>
    </ng-container>
</mat-expansion-panel>


<mat-card *ngIf="!isReady" class="custom-mat-list-item grid-row">
    <h3 matLine><skeleton-loader [theme]="{'width': '20%'}"></skeleton-loader></h3>
    <p matLine><skeleton-loader [theme]="{'width': '40%'}"></skeleton-loader></p>
</mat-card>